import {app} from '../../app';
import IScope = angular.IScope;
import {SharedQuestionService} from '../../services/SharedQuestionService';
import {ISessionService} from '../../services/SessionService';
import IComponentController = angular.IComponentController;
import {SelectSharedQuestion} from '../../sharedQuestions/SelectSharedQuestion';
import {UniqueIdService} from '../../services/UniqueIdService';

export class SelectQuestionComponent {

    protected sharedQuestionService:SharedQuestionService;
    protected sessionService:ISessionService;
    public sharedQuestion:SelectSharedQuestion;
    protected uniqueIdService:UniqueIdService;

    public nextQuestionCallback;
    public question:IQuestion;
    public value:string;
    otherValue:string;
    otherId:string;
    choices:string[] = [];

    static $inject = ['SharedQuestionService', 'SessionService', 'UniqueIdService'];

    constructor(sharedQuestionService:SharedQuestionService, sessionService:ISessionService, uniqueIdService:UniqueIdService) {
        this.sharedQuestionService = sharedQuestionService;
        this.sessionService        = sessionService;
        this.uniqueIdService       = uniqueIdService;
    }

    public $onInit = () => {
        this.sharedQuestion = new SelectSharedQuestion();

        this.setup(true);
    };

    setup(reset:boolean) {
        this.sharedQuestion.question = this.question;

        this.sharedQuestionService.questions.push(this.sharedQuestion);
        this.sharedQuestion.questionDisplayed();

        this.otherId = this.uniqueIdService.getUniqueId('select-other');

        if (reset) {
            this.choices = [];
        }

        const choices = this.question.meta.choices;
        if (choices) {
            this.choices = choices;
        }

        if (this.question.meta.emptyValue && this.choices[0] !== this.question.meta.emptyValue) {
            this.choices.unshift(this.question.meta.emptyValue);
            this.value = this.question.meta.emptyValue;
            this.update();
        }

        const defaultValue = this.question.meta.default;
        if (defaultValue && this.choices.indexOf(defaultValue) > -1) {
            this.value = defaultValue;
            this.update();
        }

        let answer = this.sessionService.getAnswer(this.question.id);
        if (answer && answer.values.length > 0 && answer.values[0]) {
            const adder = this.question.meta.emptyValue ? 1 : 0;
            this.value = this.choices[answer.values[0].choice + adder];

            if (this.question.meta.other && answer.values[0].otherValue) {
                this.otherValue = answer.values[0].otherValue;
            }

            this.update();
        }
    }

    public update() {
        let choice = this.choices.indexOf(this.value);
        if (this.question.meta.emptyValue) {
            choice -= 1;
        }

        let newValue:IValue = {
            choice: choice,
            value : this.value
        };

        if (this.question.meta.other === this.value) {
            newValue.otherValue = this.otherValue;
        }

        this.sharedQuestion.setValue(newValue);
    }

}

app.component('selectQuestion', {
    templateUrl: 'templates/components/questionTypes/selectQuestion.html',
    controller: SelectQuestionComponent,
    controllerAs: 'selectQuestion',
    bindings: {
        question: '<',
        nextQuestionCallback: '&'
    }
});